import {
  loadFixture, paginate, findBySlug, nextId, parseBody, parseQuery, mergeEntity, urlParam,
  groupIdentifierFromUrl, groupFixtureName,
} from '../mockDataStore';

const BASIC_PROFILE_FIELDS = ['id', 'slug', 'first_name', 'last_name', 'profile_picture'];

const PROFILE_DETAIL = /^\/?api\/v1\/groups\/[\w-]+\/profiles\/([\w-]+)\/?$/;
const PROFILE_SELF_DETAIL = /^\/?api\/v1\/groups\/[\w-]+\/profile\/([\w-]+)\/?$/;
const MEMBERSHIP = /^\/?api\/v1\/groups\/[\w-]+\/profile\/([\w-]+)\/membership\/?$/;
const MY_LIST = /^\/?api\/v1\/groups\/[\w-]+\/profile\/([\w-]+)\/my_list\/?$/;

export default function registerProfileMocks(mock) {
  mock.onGet(/^\/?api\/v1\/groups\/[\w-]+\/profiles\/?(\?.*)?$/).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    return [200, paginate(profiles.results, parseQuery(config.url))];
  });

  mock.onGet(/^\/?api\/v1\/groups\/[\w-]+\/basicProfiles\/?(\?.*)?$/).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    const trimmed = profiles.results.map((profile) => (
      Object.fromEntries(BASIC_PROFILE_FIELDS.map((field) => [field, profile[field]]))
    ));
    return [200, paginate(trimmed, {})];
  });

  mock.onGet(PROFILE_DETAIL).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    const profile = findBySlug(profiles.results, urlParam(config, PROFILE_DETAIL));
    return profile ? [200, profile] : [404, { message: 'Not found.' }];
  });

  mock.onPatch(PROFILE_SELF_DETAIL).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    const profile = findBySlug(profiles.results, urlParam(config, PROFILE_SELF_DETAIL));
    if (!profile) return [404, { message: 'Not found.' }];
    mergeEntity(profile, parseBody(config), ['profile_picture']);
    return [200, profile];
  });

  mock.onDelete(MEMBERSHIP).reply(async (config) => {
    const slug = urlParam(config, MEMBERSHIP);
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    profiles.results = profiles.results.filter((profile) => profile.slug !== slug);
    profiles.count = profiles.results.length;
    return [200, {}];
  });

  mock.onPost(MEMBERSHIP).reply(() => [200, {}]);

  mock.onPost(MY_LIST).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    const profile = findBySlug(profiles.results, urlParam(config, MY_LIST));
    return profile ? [200, profile] : [404, { message: 'Not found.' }];
  });

  mock.onDelete(MY_LIST).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    const profile = findBySlug(profiles.results, urlParam(config, MY_LIST));
    return profile ? [200, profile] : [404, { message: 'Not found.' }];
  });

  mock.onPost(/^\/?api\/v1\/groups\/[\w-]+\/admin-managed-profile\/?$/).reply(async (config) => {
    const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(config.url)));
    const body = parseBody(config);
    const created = {
      status: 'pending',
      is_admin: false,
      social_media: [],
      ...body,
      // Computed after the `...body` spread — see the identical note in feed.mock.js.
      id: nextId(profiles.results),
      slug: `${(body.first_name || 'new').toLowerCase()}-${(body.last_name || 'member').toLowerCase()}`,
      profile_picture: body.profile_picture instanceof Blob
        ? URL.createObjectURL(body.profile_picture)
        : null,
    };
    profiles.results.push(created);
    profiles.count += 1;
    return [201, created];
  });
}
